import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'map',
    'emptyMap',
    'siteLat',
    'siteLon',
    'parkingLat',
    'parkingLon',
    'enableParkingAddress'
  ];
  static values = {
    siteMarker: String,
    parkingMarker: String
  };

  connect() {
    if (typeof (google) != "undefined") {
      this.showMap();
    }
  }

  handleChanged() {
    this.showMap();
  }

  showMap() {
    if (this.hasSiteCoordinates() || this.hasParkingCoordinates()) {
      this.mapTarget.classList.remove('hidden');
      this.emptyMapTarget.classList.add('hidden');
      this.drawMap();
    } else {
      this.mapTarget.classList.add('hidden');
      this.emptyMapTarget.classList.remove('hidden');
    }
  }

  hasSiteCoordinates() {
    if (!(this.hasSiteLatTarget && this.hasSiteLonTarget))
      return false;

    return this.siteLatTarget.value && this.siteLonTarget.value;
  }

  hasParkingCoordinates() {
    if (!(this.hasParkingLatTarget && this.hasParkingLonTarget))
      return false;

    return this.parkingLatTarget.value && this.parkingLonTarget.value;
  }

  getSiteCoordinates() {
    if (!this.hasSiteCoordinates()) return;

    return this.getCoordinates(this.siteLatTarget.value, this.siteLonTarget.value);
  }

  getParkingCoordinates() {
    if (!this.hasParkingCoordinates()) return;

    return this.getCoordinates(this.parkingLatTarget.value, this.parkingLonTarget.value);
  }

  getEnableParkingAddress() {
    return this.hasEnableParkingAddressTarget ? this.enableParkingAddressTarget.checked : false;
  }

  drawMap() {
    let siteCoordinates = this.getSiteCoordinates();

    let parkingAddressEnabled = this.getEnableParkingAddress();
    let parkingCoordinates = this.getParkingCoordinates();

    const map = new google.maps.Map(this.mapTarget, {
      zoom: 14,
      center: siteCoordinates || parkingCoordinates,
    });

    if (siteCoordinates) {
      this.createMarker(siteCoordinates, this.siteMarkerValue, map, 'site');
    }
    if (parkingAddressEnabled && parkingCoordinates) {
      this.createMarker(parkingCoordinates, this.parkingMarkerValue, map, 'parking');
    }
  }

  createMarker(position, svg, map, elementId) {
    let marker = new google.maps.Marker({
      position: position,
      draggable: true,
      animation: google.maps.Animation.DROP,
      map,
      icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(40, 40) },
      optimized: false,
    });
    marker.addListener('dragend', (event) => {
      this.changeAddressAfterDrag(event.latLng, elementId);
    });
  };

  changeAddressAfterDrag(latlon, elementId) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latlon }, (results, status) => {
      if (status === "OK") {
        const element = document.getElementById(elementId);
        const placesController = this.application.getControllerForElementAndIdentifier(element, 'places');
        placesController.setAddressFieldsFromGeocode(results[0]);
      }
    });
  }

  getCoordinates(lat, lon) {
    if (!(lat && lon)) return;

    return {
      lat: parseFloat(lat),
      lng: parseFloat(lon)
    };
  }
}
